import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { DeliveryOption, PrintSize } from '../prop-types';
import Paginator from '../../_utils/paginator';
import screenAndStyle from '../../_utils/screen-and-style';
import PhotosListItem from './photos-list/item';
import { allPhotosCollectedByRootImage } from '../common/collect-by-root-image';
import photoRootIds from '../common/photo-root-ids';
import { sizesWithPrice } from '../common/totalizing-mixin';

class PhotosList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
    };

    this.handlePagePrevious = this.handlePagePrevious.bind(this);
    this.handlePageNext = this.handlePageNext.bind(this);
    this.handleGoToPage = this.handleGoToPage.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.pageSize = 70;
    if (screenAndStyle.isMobileBrowser()) {
      this.pageSize = 15;
    }
    if (screenAndStyle.assumePhoneOrSmallScreen()) {
      this.pageSize = 10;
    }
  }

  paginate(items) {
    const { page } = this.state;
    return items.slice((page - 1) * this.pageSize, page * this.pageSize);
  }

  handleGoToPage(page) {
    this.setState({
      page,
    });
  }

  handlePageNext() {
    this.setState(previousState => ({
      page: previousState.page + 1,
    }));
  }

  handlePagePrevious() {
    const { page } = this.state;
    if (page > 1) {
      this.setState(previousState => ({
        page: previousState.page - 1,
      }));
    }
  }

  render() {
    const { availableSizes, sizes, deliveryOption, disabled } = this.props;
    const { page } = this.state;
    const sizesAndPrice = sizesWithPrice(availableSizes, sizes, deliveryOption);
    const rootIds = photoRootIds(sizes);
    const paginatedRootIds = this.paginate(rootIds);
    const totalPageCount = Math.ceil(rootIds.length / this.pageSize);
    const allPhotosByRootImage = allPhotosCollectedByRootImage(sizes);

    return (
      <div
        className={classNames('list-view-desktop', {
          touch: screenAndStyle.isTouch(),
        })}>
        <Paginator
          title="Uploaded photos pages"
          page={page}
          totalPageCount={totalPageCount}
          scrollTarget={-200}
          onPageNext={this.handlePageNext}
          onPagePrevious={this.handlePagePrevious}
          onGoToPage={this.handleGoToPage}>
          {paginatedRootIds.map(rootId => {
            return (
              <PhotosListItem
                rootId={parseInt(rootId, 10) || rootId}
                photos={allPhotosByRootImage[rootId] || {}}
                sizes={sizesAndPrice}
                key={`${rootId}`}
                disabled={disabled}
              />
            );
          })}
        </Paginator>
      </div>
    );
  }
}

PhotosList.propTypes = {
  availableSizes: PropTypes.arrayOf(PrintSize),
  sizes: PropTypes.arrayOf(PrintSize),
  deliveryOption: DeliveryOption,
  disabled: PropTypes.bool,
}.isRequired;

export default PhotosList;
